import { UpgradeLayoutOptions } from 'layout/upgrade/upgradeLayout';
import { extractWidgetConfigFromComponents } from 'widgets/store/configuration/helpers';
import { WidgetType } from 'widgets/WidgetType';
import { CapsuleContainerWidgetConfigState } from 'widgets/tiles/store/config/CapsuleContainerWidgetConfigState';
import { WidgetConfigWithSymbol } from 'widgets/WidgetSettingsEditing/WidgetSettingsSymbolEditor';
import uniq from 'lodash/uniq';
import { initialSymbolInfoCapsuleConfigState } from 'widgets/symbolInfo/capsule/store/config/SymbolInfoCapsuleConfigState';
import { WidgetId } from 'widgets/WidgetId';

export default function upgradeLayoutToVersion2(options: UpgradeLayoutOptions) {
    const { loggingService, components } = options;

    const widgetConfigs = extractWidgetConfigFromComponents(components);

    const capsuleContainers = widgetConfigs.filter(
        (c) => c.id.widgetType === WidgetType.TILES
    );

    for (const capsuleContainer of capsuleContainers) {
        const capsuleContainerConfig = components[
            capsuleContainer.id.widgetKey
        ] as unknown as CapsuleContainerWidgetConfigState;

        moveSymbolConfigFromCapsulesToContainer(
            capsuleContainer,
            capsuleContainerConfig
        );
        addSymbolInfoToStartOfContainer(capsuleContainerConfig);
    }

    function moveSymbolConfigFromCapsulesToContainer(
        capsuleContainer: { id: WidgetId; config: Partial<unknown> },
        capsuleContainerConfig: CapsuleContainerWidgetConfigState
    ) {
        const symbols: Array<string | undefined> = [];

        if (capsuleContainerConfig.tiles) {
            for (const capsuleId of capsuleContainerConfig.tiles) {
                const capsuleConfigWithSymbol = components[
                    capsuleId.widgetKey
                ] as unknown as WidgetConfigWithSymbol;

                symbols.push(
                    capsuleConfigWithSymbol?.symbol
                        ? capsuleConfigWithSymbol?.symbol
                        : ''
                );
                if (capsuleConfigWithSymbol) {
                    capsuleConfigWithSymbol.symbol = '';
                }
            }
        }

        const uniqueSymbols = uniq(symbols);
        if (uniqueSymbols.length === 1 && !!uniqueSymbols[0]) {
            capsuleContainerConfig.symbol = uniqueSymbols[0];
            capsuleContainerConfig.hideToolbar = false;
            loggingService.debug(
                'upgradeLayoutToVersion2',
                `Set capsule container ${capsuleContainer.id.widgetKey} symbol to ${uniqueSymbols[0]}`
            );
        }
    }

    function addSymbolInfoToStartOfContainer(
        capsuleContainerConfig: CapsuleContainerWidgetConfigState
    ) {
        if (!capsuleContainerConfig.tiles) {
            capsuleContainerConfig.tiles = [];
        }
        if (
            capsuleContainerConfig.tiles[0]?.widgetType ===
            WidgetType.SYMBOL_INFO_CAPSULE
        ) {
            return;
        }

        const nextSymbolInfoKey = getNextSymbolInfoKey();
        const nextSymbolInfoId = {
            widgetType: WidgetType.SYMBOL_INFO_CAPSULE,
            widgetKey: nextSymbolInfoKey,
        };
        components[nextSymbolInfoKey] = {
            type: WidgetType.SYMBOL_INFO_CAPSULE,
            ...initialSymbolInfoCapsuleConfigState,
        };
        widgetConfigs.push({
            id: nextSymbolInfoId,
            config: initialSymbolInfoCapsuleConfigState,
        });
        capsuleContainerConfig.tiles = [
            nextSymbolInfoId,
            ...capsuleContainerConfig.tiles,
        ];
    }

    function getNextSymbolInfoKey() {
        let nextId = 0;
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // Increment until we find an unused id...
            const nextKey = `${WidgetType.SYMBOL_INFO_CAPSULE}-${nextId}`;
            const existsInLayout = !!widgetConfigs.find(
                (e) => e.id.widgetKey === nextKey
            );

            if (!existsInLayout) {
                return nextKey;
            }
            nextId++;
        }
    }
}
